module.exports = __webpack_public_path__ + "img/knowledge.e7973ffa.svg";